import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from "./Pages/Shop.jsx";
import ShopCategory from "./Pages/ShopCategory";
import Product from "./Pages/Product";
import Cart from "./Pages/Cart";
import LoginSignup from "./Pages/LoginSignup";
import Checkout from "./Pages/Checkout";
import OrderSuccess from "./Pages/OrderSuccess";
import Footer from "./Components/Footer/Footer.jsx";
import ContactUs from "./Pages/ContactUs.jsx";
import WhatsAppButton from "./Components/WhatsappButton/WhatsappButton.jsx";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Shop />} />
        <Route path="/beardoil" element={<ShopCategory category="beardoil" />} />
        <Route path="/hairoil" element={<ShopCategory category="hairoil" />} />
        <Route path="/soap" element={<ShopCategory category="soap" />} />
        <Route path="/product/:productId" element={<Product />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<LoginSignup />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
      </Routes>

      <Footer />

      <WhatsAppButton
        phone="447759818509"
        message="Hello! I want to know more about your products."
      />
    </BrowserRouter>
  );
}

export default App;
